import * as actions from './actions'
import * as getters from './getters'

import {
  SET_USER_LOCATION,
  SET_DELIVERY_TYPE,
  SET_ORDER_DELIVERY_TYPE,
  SET_ORDER_POSTCODE,
  SET_RESTAURANT,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  UPDATE_CART_PRODUCT,
  CLEAR_CART
} from './mutation-types'

// This module state will be persisted by vuex-persistedstate
const initialState = {
  userLocation: null,
  deliveryType: null,
  orderDeliveryType: null,
  orderPostcode: null,
  restaurant: null,
  items: []
}

const mutations = {
  [SET_USER_LOCATION] (state, location) {
    state.userLocation = location
  },
  [SET_DELIVERY_TYPE] (state, type) {
    state.deliveryType = type
  },
  [SET_ORDER_DELIVERY_TYPE] (state, type) {
    state.orderDeliveryType = type
  },
  [SET_ORDER_POSTCODE] (state, postcode) {
    state.orderPostcode = postcode
  },
  [SET_RESTAURANT] (state, restaurant) {
    state.restaurant = restaurant
  },
  [ADD_TO_CART] (state, cartItem) {
    state.items.push(cartItem)
  },
  [REMOVE_FROM_CART] (state, cartItemProductId) {
    state.items = state.items.filter(item => item.product.id !== cartItemProductId)
  },
  [INCREASE_ITEM_QUANTITY] (state, cartItem) {
    state.items = state.items.map(item => {
      if (item.product.id === cartItem.product.id) {
        item.quantity++
      }
      return item
    })
  },
  [DECREASE_ITEM_QUANTITY] (state, cartItem) {
    if (cartItem.quantity < 2) {
      return
    }

    state.items = state.items.map(item => {
      if (item.product.id === cartItem.product.id) {
        item.quantity--
      }
      return item
    })
  },
  [UPDATE_CART_PRODUCT] (state, payload) {
    state.items[payload.index].product = payload.product
  },
  [CLEAR_CART] (state) {
    state.items = []
  }
}

export default {
  state: initialState,
  actions,
  getters,
  mutations
}




// WEBPACK FOOTER //
// ./src/vuex/modules/cart/index.js